<template>
    <v-dialog v-model="photoModal" max-width="400px">
        <v-card>
            <div class="modal-header">
                <v-btn class="ml-2" icon @click="goBack()" v-if="isCameraOpen"><v-icon>mdi-arrow-left</v-icon></v-btn>
                <h4 class="modal-headline">{{ $page.props.lang.choose_profile_photo || 'Choose profile photo' }}</h4>
                <v-btn icon @click="closePhotoModal()"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <div>
                <v-card-text>
                    <div class="image" v-if="!isCameraOpen">
                    <v-img :src="member.profile_photo_url" alt="" height="210" width="340"></v-img>
                    </div>
                    <h2 v-if="!isCameraOpen" style="font-size:18px" class="text-center mt-3">{{$page.props.lang.choose_photo || "Choose a photo or take a new one"}}</h2>
                    <v-container class="mb-4">
                        <v-row v-if="!isCameraOpen">
                            <v-col cols="6" class="text-center">
                            <div v-show="$page.props.p['members.manage']">
                               <v-btn class="mt-2" fab small>
                                <v-file-input
                                    class="mb-4 pl-2"
                                    color="primary"
                                    v-model="memberPhoto"
                                    hide-input
                                    prepend-icon="mdi-upload"
                                    @change="onFileChange">
                                </v-file-input>
                                </v-btn>
                            </div>
                            </v-col>
                            <v-col cols="6" class="text-center">
                                <v-btn @click="toggleCamera" class="mt-2" fab small>
                                    <v-icon>mdi-camera</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <div v-if="isCameraOpen" class="canvas mb-4">   
                            <div class="text-center">     
                                <video v-show="!isPhotoTaken" ref="camera" :width="canvasWidth" :height="canvasHeight" autoplay></video>
                                <canvas  v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="canvasWidth" :height="canvasHeight"></canvas>  
                                <v-container class="mt-2">
                                    <v-row> 
                                        <v-col>      
                                            <div v-if="isCameraOpen">
                                                <v-btn @click="takePhoto" class="shutter-btn">
                                                    <v-icon v-if="isPhotoTaken && isCameraOpen" color="primary">mdi-replay</v-icon>
                                                    <v-icon v-else color="primary">mdi-camera-plus</v-icon>
                                                </v-btn>
                                            </div>
                                        </v-col>
                                        <v-col>
                                            <div>
                                                <v-btn v-if="this.$vuetify.breakpoint.smAndUp" style="margin-right:50px" :disabled="isDisabled" @click="uploadPhoto" color="primary">
                                                    <v-icon left>mdi-upload</v-icon>
                                                    <span>{{ $page.props.lang.upload_photo || 'Upload' }}</span>
                                                </v-btn>
                                                <v-btn v-else style="margin-left:25px" class="mb-2" :disabled="isDisabled" @click="uploadPhoto" color="primary" fab small>
                                                    <v-icon>mdi-upload</v-icon>
                                                </v-btn>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </div>
                        </div>
                    </v-container>
                </v-card-text>
            </div>
        </v-card>
    </v-dialog>
</template>

<style scoped>
    .image{
        display: block;
        margin-left: auto;
        margin-right: auto;
        max-width: 210px;
        max-height: 210px;
        min-width: 210px;
        min-height: 210px;
        position: relative;
        overflow: hidden;
        border-radius: 10%;
    }

    @media only screen and (max-width: 420px) {
        .image {
            max-width: 180px;
            max-height: 180px;
            min-width: 180px;
            min-height: 180px;
        }
    }   
    .canvas{
        height:270px;
    }

    @media only screen and (max-width: 420px) {
        .canvas {
            height:190px;
        }  
    }  
    
</style>
<script>

import { VueEditor, Quill } from "vue2-editor";
import throttle from 'lodash/throttle'
import EventBus from '@/js/eventbus'
import Label from '../../../../Jetstream/Label.vue';


export default {
    components: { VueEditor },
    
        Labelname:'ProfilePhotoModal',
    props: {
        open: Boolean,
        member: Object
    },

    data(){
      return {
           memberPhoto:null,
           imageLoading:false,
           isCameraOpen: false,
           isPhotoTaken: false,
           isShotPhoto: false,
        //    canvasWidth:260,
        //    canvasHeight:195,
           currentTakenPhoto: null
      }
    },
    computed: {

        canvasWidth(){
            if(this.$vuetify.breakpoint.smAndUp){
                return 260;
            }else{
                return 180;
            }
        },
        canvasHeight(){

            if(this.$vuetify.breakpoint.smAndUp){
                return 195;
            }else{
                return 140;
            }
        },

        isDisabled(){
            if(this.isPhotoTaken && this.isCameraOpen){
                return false;
            }else{
                return true;
            }
        },
       
       photoModal: {
            get: function() {
                return this.open
            },
            set: function() {
                this.$emit('close')
                if(this.isCameraOpen == true){
                 this.stopCameraStream();
                }
                return false
            }
        }
    },
    created(){
        
    },

    watch: {
       
    },
    methods: {
        goBack(){
            this.stopCameraStream();
            this.isCameraOpen = false;
        },
        focusOut(){
            if(this.isCameraOpen == true){
                 this.stopCameraStream();
            }
            this.photoModal = false;
        },
        closePhotoModal(){
            if(this.isCameraOpen == true){
                 this.stopCameraStream();
            }
            this.photoModal = false;
        },
        onFileChange() {
            if(this.memberPhoto) {
                let file =  this.memberPhoto
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                let formData = new FormData()
                formData.append('photo', file)
                formData.append('member_id', this.member.id)
                axios.post('/backoffice/members/uploadphoto', formData, config)
                    .then(response => {
                        var color = 'success';
                        if (response.data.status==="OK") {
                            this.photoModal = false;
                            
                            this.$page.props.member.profile_photo_url = response.data.photo_path;
                        }else{
                            color = 'error';
                        }
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: color,
                                timeout: 5000
                            })
                    })
                    .catch(error => {
                        if(error) {
                            EventBus.$emit('SHOW_NOTIFICATION',{
                                message: error.response.data.errors.photo['0'],
                                color: 'error',
                                timeout: 5000
                            })
                            
                        }
                    })
            }
        },

        toggleCamera() {

            if(this.isCameraOpen) {
                this.isCameraOpen = false;
                this.isPhotoTaken = false;
                this.isShotPhoto = false;
                this.stopCameraStream();
            } else {
                this.isCameraOpen = true;
                this.createCameraElement();
            }
        },

        createCameraElement() {
            this.isLoading = true;
        
            var constraints = (window.constraints = {
                        audio: false,
                        video: true
                    });

			navigator.mediaDevices 
				.getUserMedia(constraints)
				.then(stream => {
                    this.isLoading = false;
					this.$refs.camera.srcObject = stream;
				})
				.catch(error => {
                    this.isLoading = false;
					alert(this.$page.props.lang.camera_error || "This page has been blocked from using your camera. Enable the camera to take photo.");
                    this.photoModal = false;
				});
        },

        stopCameraStream() {
            let tracks = this.$refs.camera.srcObject.getTracks();

                    tracks.forEach(track => {
                        track.stop();
                    });
        },

        takePhoto() {
            if(!this.isPhotoTaken) {
                this.isShotPhoto = true;

                const FLASH_TIMEOUT = 50;

                setTimeout(() => {
                this.isShotPhoto = false;
                }, FLASH_TIMEOUT);
            }
            
            this.isPhotoTaken = !this.isPhotoTaken;
            
            const context = this.$refs.canvas.getContext('2d');
            context.drawImage(this.$refs.camera, 0, 0, this.canvasWidth, this.canvasHeight);
            const dataUrl = this.$refs.canvas.toDataURL("image/jpeg");
            this.currentTakenPhoto = dataUrl;

        },

        uploadPhoto(){
            if(this.currentTakenPhoto) {
                this.stopCameraStream();
                let file =  this.currentTakenPhoto
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                let formData = new FormData()
                formData.append('photo', file)
                formData.append('member_id', this.member.id)
                axios.post('/backoffice/members/takephoto', formData, config)
                    .then(response => {
                        var color = 'success';
                        if (response.data.status==="OK") {
                            this.photoModal = false;
                            
                            this.$page.props.member.profile_photo_url = response.data.photo_path;
                        }else{
                            color = 'error';
                        }
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: color,
                                timeout: 5000
                            })
                    })
                    .catch(error => {
                        if(error) {
                            EventBus.$emit('SHOW_NOTIFICATION',{
                                message: error.response.data.message,
                                color: 'error',
                                timeout: 5000
                            })
                            
                        }
                    })
            }
        }
    }
}
</script>
